module.exports = __webpack_public_path__ + "static/NotoSans-Italic.subset-4421743d06e2fdee5b3db96abcd7985e.woff";